__turbopack_context__.v({
  "badge": "dSJBkW_badge",
  "badge--secondary": "dSJBkW_badge--secondary",
  "badge--tertiary": "dSJBkW_badge--tertiary",
  "badge__icon-container": "dSJBkW_badge__icon-container",
});
